"use strict";
module.exports = typeof Reflect !== "undefined" && Reflect.getPrototypeOf || null;
